import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const TemplateWrapper = styled.div`
  background: ${myPalette.blue.main};
  border-radius: 16px;
  padding: 18px 56px;
  display: flex;
  align-items: center;
  justify-content: center;
`
